import React, { useState, useEffect, useMemo } from "react";

import { Modal, Button } from "react-bootstrap";

import Selector from "../../../components/selector";

import {
  StyledCol,
  StyledContainerButtonsExtra,
  StyledGrid,
  StyledModalBody,
  StyledModalButton,
  StyledModalCloseButton,
  StyledRow,
} from "../styled";
import { CardExtra } from "./CardExtra";
import { CardInventory } from "./CardInventory";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { add, differenceInDays, format } from "date-fns";
import { es } from "date-fns/locale";

const messages = defineMessages({
  modalsTitle: {
    id: "quotation.modals.title",
    defaultMessage: "Cotizador Grupos",
  },
  modalsBodyPriceByRoom: {
    id: "quotation.modals.bodyPriceByRoom",
    defaultMessage: "El precio mostrado es total por habitacion",
  },
  modalsOccupant: {
    id: "quotation.modals.occupant",
    defaultMessage: "Ocupación",
  },
  modalsAdults: {
    id: "quotation.modals.adults",
    defaultMessage: "adultos",
  },
  modalsJuniors: {
    id: "quotation.modals.juniors",
    defaultMessage: "juniors",
  },
  modalsChildren: {
    id: "quotation.modals.children",
    defaultMessage: "niños",
  },
  modalsBabies: {
    id: "quotation.modals.babies",
    defaultMessage: "bebes",
  },
  modalsAccommodations: {
    id: "quotation.modals.accommodations",
    defaultMessage: "alojamientos",
  },
  modalsExtras: {
    id: "quotation.modals.extras",
    defaultMessage: "Extras",
  },
  modalsCancel: {
    id: "quotation.modals.cancel",
    defaultMessage: "Cancelar",
  },
  modalsConfirm: {
    id: "quotation.modals.confirm",
    defaultMessage: "Confirmar",
  },
  alternativeOccupation: {
    id: "quotation.modals.alternativeOccupation",
    defaultMessage: "alternativeOccupation",
  },
});

export const ModalAccomodations: any = ({
  showModal,
  onHideModal,
  dataInventories = [],
  ratioCurrency,
  changeMealPlanInventory,
  changeRoomInventory,
  handleSelectRoom,
  tabs,
  actualTab,
  actualRoom,
  showAlternativeOccupation,
  setOccupations,
}: any) => {
  const intl = useIntl();
  const [optionsFilterInventory, setOptionsFilterInventory] = useState<any[]>([]);
  const [selectOptionsFilterInventory, setSelectOptionsFilterInventory] = useState(null);

  const [filteredDataInventory, setFilteredDataInventory] = useState<any[]>([]);

  const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
  const tab = tabs[indexTab];

  const valuesRoomAccommodation = tab?.accommodations?.[actualRoom];

  const adultsValue = valuesRoomAccommodation?.adults?.value || 0;
  const juniorsValue = valuesRoomAccommodation?.juniors?.value || 0;
  const childrensValue = valuesRoomAccommodation?.childrens?.value || 0;
  const babiesValue = valuesRoomAccommodation?.babies?.value || 0;

  const getLabelOccupation = (intl: any) => {
    let message = `${intl.formatMessage(messages.modalsOccupant)} `;
    if (tab?.configurations?.maxAdults > 0) {
      message += `${adultsValue} ${intl.formatMessage(messages.modalsAdults)}`;
    }
    if (tab?.configurations?.maxTeenagers > 0) {
      message += `, ${juniorsValue} ${intl.formatMessage(messages.modalsJuniors)}`;
    }
    if (tab?.configurations?.maxChildren > 0) {
      message += `, ${childrensValue} ${intl.formatMessage(messages.modalsChildren)}`;
    }
    if (tab?.configurations?.maxBabies > 0) {
      message += `, ${babiesValue} ${intl.formatMessage(messages.modalsBabies)}`;
    }
    return message;
  };

  const handleFilterInventory = (value: any) => {
    if (value?.value === null) {
      setFilteredDataInventory(dataInventories);
      setSelectOptionsFilterInventory(null);
    } else {
      setSelectOptionsFilterInventory(value);
      const indexInventory = dataInventories.findIndex(
        (inventory: any) => inventory.accommodation === value.value
      );
      setFilteredDataInventory([dataInventories[indexInventory]]);
    }
  };

  useEffect(() => {
    if (!selectOptionsFilterInventory) {
      setFilteredDataInventory(dataInventories);
    }
  }, [dataInventories, selectOptionsFilterInventory]);

  useEffect(() => {
    const inventories: any[] = [];
    dataInventories.forEach((inventory: any) => {
      if (
        !inventories.some((itemInventory: any) => itemInventory.value === inventory.accommodation)
      ) {
        inventories.push({ value: inventory.accommodation, label: inventory.nameAccommodation });
      }
    });
    setOptionsFilterInventory(inventories);
  }, [dataInventories]);

  /*
  useEffect(() => {
    setSelectOptionsFilterInventory(null);
    if (valuesRoomAccommodation?.ticker && showModal) {
      const indexInventory = dataInventories.findIndex(
        (inventory: any) => inventory.ticker === valuesRoomAccommodation?.ticker
      );
      changeMealPlanInventory(indexInventory, valuesRoomAccommodation?.mealPlan);
    }
  }, [
    changeMealPlanInventory,
    dataInventories,
    showModal,
    valuesRoomAccommodation?.mealPlan,
    valuesRoomAccommodation?.ticker,
  ]);
  */

  return (
    <Modal centered size="xl" show={showModal} onHide={() => onHideModal()}>
      <Modal.Header style={{ background: "#008C6B", color: "white" }} closeButton>
        <div style={{ fontSize: "20px", fontWeight: 600 }}>
          <FormattedMessage {...messages.modalsTitle} />
        </div>
      </Modal.Header>
      <StyledModalBody>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ color: "#656565", fontSize: "21px", fontWeight: 600 }}>
            {getLabelOccupation(intl)}
          </span>
          <span
            style={{
              color: "#F01212",
              fontSize: "13px",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              marginLeft: "20px",
            }}>
            {showAlternativeOccupation && (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="15"
                  viewBox="0 0 18 15"
                  fill="#F01212"
                  style={{
                    marginRight: "5px",
                  }}>
                  <path
                    d="M9.81818 9.47368H8.18182V5.52632H9.81818M9.81818 12.6316H8.18182V11.0526H9.81818M0 15H18L9 0L0 15Z"
                    fill="#F01212"
                  />
                </svg>
                <FormattedMessage {...messages.alternativeOccupation} />
              </>
            )}
          </span>
        </div>
        <div style={{ color: "#656565", fontSize: "13px" }}>
          <FormattedMessage {...messages.modalsBodyPriceByRoom} />
        </div>
        <hr />

        <div style={{ maxWidth: "100%" }}>
          <Selector
            options={[
              { value: null, label: intl.formatMessage(messages.modalsAccommodations) },
              ...optionsFilterInventory,
            ]}
            value={selectOptionsFilterInventory}
            onChange={(selectedOption: any) => handleFilterInventory(selectedOption)}
            placeholder={intl.formatMessage(messages.modalsAccommodations)}
          />
        </div>

        {filteredDataInventory.map((inventory: any, indexInventory: number) => {
          return (
            <CardInventory
              key={inventory.id}
              inventory={inventory}
              ratioCurrency={ratioCurrency}
              tab={tab}
              changeMealPlanInventory={changeMealPlanInventory}
              changeRoomInventory={changeRoomInventory}
              handleSelectRoom={handleSelectRoom}
              indexInventory={indexInventory}
              actualRoom={actualRoom}
              setOccupations={setOccupations}
            />
          );
        })}
      </StyledModalBody>
    </Modal>
  );
};

export const ModalExtras: any = ({
  showModal,
  onHideModal,
  dataExtraRoom,
  setDataExtrasRoom,
  tabs,
  actualTab,
  handleConfirm,
  ratioCurrency,
}: any) => {
  const [listDate, setListDate] = useState<string[]>([]);

  const currency = useMemo(() => {
    const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
    const tab = tabs[indexTab];
    return tab?.currency?.label;
  }, [actualTab, tabs]);

  useEffect(() => {
    const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
    const tab = tabs[indexTab];
    if (showModal) {
      const tempListDate: string[] = [];
      const startReservation = new Date(tab.checkIn);
      const endReservation = new Date(tab.checkOut);
      const diffDates = differenceInDays(endReservation, startReservation);
      for (let index = 0; index < diffDates; index++) {
        tempListDate.push(
          format(add(new Date(tab.checkIn), { days: index }), "yyyy-MM-dd", {
            locale: es,
          }).toLocaleUpperCase()
        );
      }

      setListDate(tempListDate);
    }
  }, [actualTab, showModal, tabs]);

  return (
    <Modal centered size="xl" show={showModal} onHide={() => onHideModal(false)}>
      <Modal.Header style={{ background: "#008C6B", color: "white" }} closeButton>
        <div style={{ fontSize: "20px", fontWeight: 600 }}>
          <FormattedMessage {...messages.modalsExtras} />
        </div>
      </Modal.Header>
      <StyledModalBody>
        {dataExtraRoom.map((extra: any, indexExtraRoom: number) => (
          <CardExtra
            key={extra.ticker}
            ratioCurrency={ratioCurrency}
            extra={extra}
            listDate={listDate}
            dataExtraRoom={dataExtraRoom}
            setDataExtrasRoom={setDataExtrasRoom}
            indexExtraRoom={indexExtraRoom}
            currency={currency}
          />
        ))}
        <StyledContainerButtonsExtra>
          <Button style={{ width: "120px" }} onClick={() => handleConfirm()}>
            <FormattedMessage {...messages.modalsConfirm} />
          </Button>
          <StyledModalCloseButton
            marginLeft="20px"
            width="120px"
            onClick={() => onHideModal(false)}>
            <div style={{ fontWeight: 600 }}>
              <FormattedMessage {...messages.modalsCancel} />
            </div>
          </StyledModalCloseButton>
        </StyledContainerButtonsExtra>
      </StyledModalBody>
    </Modal>
  );
};

export const ModalConfirmation: any = ({
  textBody,
  showModal,
  onHideModal,
  handleOk,
  handleCancel,
  textHeader,
  twoButtons = true,
  txtOk = "Sí",
  txtCancel = "Volver",
  size = "sm",
}: any) => {
  return (
    <Modal centered size={size} show={showModal} onHide={onHideModal}>
      {textHeader && (
        <Modal.Header style={{ background: "#008C6B", color: "white" }} closeButton>
          <div style={{ fontSize: "20px", fontWeight: 600 }}>{textHeader} </div>
        </Modal.Header>
      )}

      <StyledModalBody>
        {textBody}
        <StyledGrid padding={"20px"}>
          <StyledRow>
            <StyledCol
              xs={twoButtons ? 6 : 12}
              style={{ justifyContent: twoButtons ? "flex-end" : "center" }}>
              <StyledModalButton onClick={handleOk}>
                <div style={{ fontWeight: 600 }}> {txtOk} </div>
              </StyledModalButton>
            </StyledCol>

            {twoButtons && (
              <StyledCol xs={6}>
                <StyledModalCloseButton marginLeft={"0px"} onClick={handleCancel}>
                  <div style={{ fontWeight: 600 }}> {txtCancel} </div>
                </StyledModalCloseButton>
              </StyledCol>
            )}
          </StyledRow>
        </StyledGrid>
      </StyledModalBody>
    </Modal>
  );
};
